import React from 'react';
import {Button, Intent, NonIdealState} from "@blueprintjs/core";

const PermissionDenied = () => {
  return (
    <NonIdealState
      title='你暂未购买课程'
      description='你可以点击下面按钮跳转至课程售卖页面进行购买'
      icon='blocked-person'
      action={<Button onClick={() => window.open('http://www.pythontip.com/sales', '_self')} intent={Intent.WARNING} large icon='shopping-cart'>去购买课程</Button>}
    />
  );
};

export default PermissionDenied;
